import Konva from 'konva'

// Helper function to wait for all Konva images to load
export const waitForKonvaImagesToLoad = async (stage: Konva.Stage, getMapLoading: () => boolean): Promise<void> => {
  // First wait for the background map image to load if it's being loaded
  if (getMapLoading()) {
    await new Promise<void>((mapResolve) => {
      const checkMapLoaded = () => {
        if (!getMapLoading()) {
          mapResolve()
        } else {
          setTimeout(checkMapLoaded, 200)
        }
      }
      checkMapLoaded()
    })
  }

  // Then wait for all Konva images to load
  return new Promise<void>((resolve) => {
    // Get all image nodes from the stage
    const imageNodes = stage.find('Image') as Konva.Image[]

    // Filter images that are still loading
    const loadingImages = imageNodes.filter(node => {
      const image = node.image()
      // Check if it's an HTMLImageElement which has the 'complete' property
      return image && (image as HTMLImageElement).nodeType === 1 && !(image as HTMLImageElement).complete
    })

    if (loadingImages.length === 0) {
      return resolve()
    }

    let loadedCount = 0
    const checkAllLoaded = () => {
      loadedCount++
      if (loadedCount === loadingImages.length) {
        resolve()
      }
    }

    loadingImages.forEach(node => {
      const image = node.image() as HTMLImageElement
      if (image) {
        image.addEventListener('load', checkAllLoaded)
        image.addEventListener('error', checkAllLoaded)
      } else {
        checkAllLoaded() // Skip if no image element
      }
    })
  })
}
